export default __webpack_public_path__ + "static/media/pp-w-10.119045fd.svg";